export interface LikeParam {
  serviceId: LikeServiceType
  contentId: number
  naverId?: string
  reactionType?: LikeReactionType
}

export interface LikesParam {
  serviceId: LikeServiceType
  contentIds: number[]
  naverId?: string
}

export interface LikeReactions {
  reactionType: string
  count: number
  isReacted: boolean
}

export interface Like {
  serviceId: string
  contentsId: string
  reactions: LikeReactions[]
}

export interface Likes {
  contents: Like[]
}

export enum LikeEnvironment {
  PCW = 'pcw',
  MBW = 'mbw',
  MBA = 'mba',
}

// TODO - window 와 smartstore 분기 여부 구분 필요 여부 확인
export enum LikeServiceType {
  'SMARTSTORE' = 'SMARTSTORE',
}

export enum LikeReactionType {
  'USEFUL' = 'useful',
}

export interface HelpCountParam {
  id: number
  helpCount: number
  isMyLike: boolean
}
